<template>
  <div>
    <PrepareBlockingModal ref="refPrepareBlockingModal" />
  </div>
</template>

<script>
import {
  provide,
  onActivated,
  onDeactivated,
} from '@vue/composition-api'
import PrepareBlockingModal from './PrepareBlockingModal.vue'
import blockingAnAccessSession from './blockingAnAccessSession'

export default {
  name: 'BlockingAnAccessSession',
  components: {
    PrepareBlockingModal,
  },
  setup() {
    const {
      // Свойства
      onActivatedBlockingAnAccessSession,
      refPrepareBlockingModal,
      refBlockingModal,
      timeIntervalString,
      // Методы
      hideModal,
      showModal,
      onSubmit,
    } = blockingAnAccessSession()

    onActivated(() => {
      onActivatedBlockingAnAccessSession.value = true
    })

    onDeactivated(() => {
      onActivatedBlockingAnAccessSession.value = false
    })

    const provideVariables = {
      refPrepareBlockingModal,
      refBlockingModal,
      timeIntervalString,
    }

    const provideFunctions = {
      hideModal,
      showModal,
      onSubmit,
    }

    provide('blockingAnAccessSession', { variables: provideVariables, functions: provideFunctions })

    return {
      // Свойства
      ...provideVariables,
      // Методы
      ...provideFunctions,
    }
  },
}
</script>

<style scoped lang="scss">

</style>
